export function changeLoading(loading) {
	return {
		type: "@confirmToken/CHANGE_LOADING",
		payload: {
			loading,
		},
	};
}

export function validateTokenConfirmPhoneRequest(token, withRedirect) {
	return {
		type: "@confirmToken/VALIDATE_TOKEN_CONFIRM_PHONE_REQUEST",
		payload: { token, withRedirect },
	};
}

export function failPincodeNewAccount(param) {
	return {
		type: "@confirmToken/FAIL_PINCODE_NEW_ACCOUNT",
		payload: { param },
	};
}

export function validateTokenConfirmPhoneSuccess(data) {
	return {
		type: "@confirmToken/VALIDATE_TOKEN_CONFIRM_PHONE_SUCCESS",
		payload: { data },
	};
}

export function validateTokenConfirmPhoneError(data) {
	return {
		type: "@confirmToken/VALIDATE_TOKEN_CONFIRM_PHONE_ERROR",
		payload: { data },
	};
}

export function sendTokenRequest(vl_full_phone_number) {
	return {
		type: "@confirmToken/SEND_TOKEN_REQUEST",
		payload: { vl_full_phone_number },
	};
}

export function respResendPhoneConfirmation(param) {
	return {
		type: "@confirmToken/RESP_RESEND_PHONE_CONFIRMATION",
		payload: { param },
	};
}

export function sendRegisterCelPhoneRequest(cd_access_token, vl_full_phone_number, operation_system, type_to_send) {
	return {
		type: "@confirmToken/SEND_REGISTER_CEL_PHONE",
		payload: { cd_access_token, vl_full_phone_number, operation_system, type_to_send },
	};
}

export function respSendRegisterCelPhone(param) {
	return {
		type: "@confirmToken/RESP_SEND_REGISTER_CEL_PHONE",
		payload: { param },
	};
}
